/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export default class NavHVAButtonActions {
	static fiCodeToSapCodeMap = {
		after_effects_cc: 'AEFT',
		acrobat_dc_pro: 'APRO',
		adobe_capture: 'capture',
		adobe_comp: 'comp',
		adobe_media_encoder: 'mediaencoder',
		adobe_photoshop_on_ipad: 'PHSP', // multiple photoshops
		aftereffects_cc: 'AEFT',
		ai_draw: 'draw',
		audition_cc: 'AUDT',
		cc: 'KCCC', // note: there's three creative cloud apps
		cc_storage: 'KCCC',
		characteranimator_cc: 'CHAR',
		ctsk_direct_indirect_team: 'stock',
		dimension_cc: 'ESHR',
		dreamweaver_cc: 'DRWV',
		experiencedesign_cc: 'SPRK', // XD
		flash_professional_cc: 'animate', // animate
		fresco: 'FRSC',
		hammersmith: 'premiereclip',
		indesign_cc: 'IDSN',
		illustrator_cc: 'ILST',
		lightroom_cc: 'LRCC', // two lightroomccs
		muse_cc: 'MUSE',
		nimbus_cc: 'LRCC',
		photoshop_cc: 'PHSP',
		premierepro_cc: 'PPRO',
		premiere_pro_cc: 'PPRO', // two premiere pros: JIL returns PPRO differently
		// so we have to do this
		premiere_rush_cc: 'RUSH',
		ps_fix: 'fix',
		ps_mix: 'photoshopmix',
		ps_sketch: 'sketch',
		stock_assets: 'stock', // two stocks
		team_projects: 'KCCC',
		xd_cc: 'SPRK',
	};

	// send 'launch' command to WAM and open up the app directly
	static launchApp(sapcode, status, wam) {
		// Possibly might want to differentiate if app is not the latest version
		// const canOpen = status.installed;
		// const canUpdate = !status.latest;

		NavHVAButtonActions.appActions(sapcode, status.version, wam, 'launch');
	}

	// function to send context for actions such as 'launch' and 'install'
	static appActions(sapcode, version, wam, action) {
		const cmdContext = {
			sapCode: sapcode,
			version,
			commandPayload: {
				command: action,
			},
			isConfirmationType: false,
		};
		wam.sendCommand(cmdContext);
	}

	// Check whether user is entitled to app with sapcode
	static checkEntitled = (sapCode) => {
		if (sessionStorage && sessionStorage.getItem('cchome_raw_profile')) {
			const profile: any = sessionStorage.getItem('cchome_raw_profile');
			const userData = JSON.parse(profile);
			for (const sub of userData.account.subscriptions.paid) {
				for (const ent of sub.entitlements) {
					if (NavHVAButtonActions.fiCodeToSapCodeMap[ent] === sapCode) {
						return true;
					}
				}
			}
		}
		return false;
	};

	// check whether the list being passed in contains an app according to the sapcode, else return false
	static containsApp = (sapCode, listToCheck) => {
		for (const app of listToCheck) {
			if (app.sapcode === sapCode) {
				return app;
			}
		}
		return false;
	};
}
